import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInbraak = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M27.15 9.32H12.44v4.41h14.71z"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M19.22 11.66a2.001 2.001 0 0 1-3.76-1.37M24.54 10.29a2.002 2.002 0 1 1-3.76 1.37"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m17.13 9.07 2.73.99-.34.94-2.73-.99zM23.21 10.01l-2.73.99-.34-.94 2.73-.99z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInbraak);

export default ForwardRef;
